/** Estado observable del stack social, en un módulo aparte y sin dependencias.
 *
 *  Vive separado de `index.js` a propósito: la barra de navegación necesita
 *  pintar el indicador de conexión en TODAS las páginas, y no queremos que eso
 *  arrastre el orquestador (ni, por extensión, el wasm) al bundle inicial de
 *  quien no usa el multijugador.
 */
import { browser } from '$app/environment'
import { derived, writable } from 'svelte/store'

/** 'off' | 'starting' | 'ready' | 'passive' | 'error' */
export const status = writable('off')
export const myId = writable('')
/** topicId -> nº de vecinos del swarm */
export const neighbourCounts = writable({})
/** ¿Hay red? El navegador lo sabe antes que el transporte. */
export const online = writable(browser ? navigator.onLine : true)

/** Lo que pinta el indicador de la barra: si estamos conectados y a cuántos
 *  pares vemos en total (sumando todos los grupos). */
export const connection = derived(
  [status, neighbourCounts, online],
  ([$status, $counts, $online]) => {
    const peers = Object.values($counts).reduce((a, b) => a + (b || 0), 0)
    const connected = $online && $status === 'ready'
    return {
      connected,
      peers,
      // 0..9 y a partir de ahí "+", para que no crezca la burbuja.
      label: peers > 9 ? '+' : String(peers),
      title: !$online
        ? 'Sin conexión'
        : $status === 'passive'
        ? 'Conectado desde otra pestaña'
        : $status === 'ready'
        ? `${peers} ${peers === 1 ? 'par conectado' : 'pares conectados'}`
        : $status === 'starting'
        ? 'Conectando…'
        : 'Desconectado'
    }
  }
)
